import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import "../assets/style.scss"

const LandingFooter = () => {
  return (
    <Block type="footer" className="landing-footer-container">
      <Block className="landing-footer-wrapper">
        <Block className="landing-footer-text">
          <Block>{"Akbank Aile Bankacılığı"}</Block>
        </Block>
      </Block>
      <Image path={"./img/ferdikazasigortalead/ferdi-kaza-sigorta.png"} className="landing-footer-img" />
    </Block>
  )
}

export default LandingFooter
